import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { RoadmapPage } from "@/components/strategy-v2/roadmap/RoadmapPage";
import { useRoadmap } from "@/hooks/use-roadmap";

export const Route = createFileRoute("/_app/_/strategy/roadmap")({
	component: StrategyRoadmapPage,
});

function StrategyRoadmapPage() {
	const { data, isLoading, error } = useRoadmap();

	if (isLoading) {
		return (
			<div className="flex items-center justify-center min-h-[60vh]">
				<Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
			</div>
		);
	}

	if (error || !data?.boulders?.length) {
		return (
			<div className="flex items-center justify-center min-h-[60vh]">
				<div className="text-center space-y-3 max-w-md">
					<h2 className="text-xl font-semibold text-foreground">
						Roadmap Not Available
					</h2>
					<p className="text-sm text-muted-foreground">
						Your campaign roadmap will be generated once your
						strategy is approved. Check back soon.
					</p>
				</div>
			</div>
		);
	}

	return <RoadmapPage boulders={data.boulders} />;
}
